export default "__VITE_ASSET__BuwiV4bz__"